"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalDataActions = void 0;
exports.loadBusinessPartner = loadBusinessPartner;
exports.loadCurrentPersonalData = loadCurrentPersonalData;
exports.passwordReset = passwordReset;
exports.resetApiError = resetApiError;
exports.savePersonalData = savePersonalData;
exports.setApiError = setApiError;
exports.setLoader = setLoader;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _accountDataApi = require("../../../api-factory/accountDataApi");
var _myDataApi = require("../../../api-factory/myDataApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PersonalDataActions = exports.PersonalDataActions = /*#__PURE__*/function (PersonalDataActions) {
  PersonalDataActions["LOAD_CURRENT_PERSONAL_DATA"] = "api/reducer/GET_PERSONAL_DATA";
  PersonalDataActions["SAVE_MY_DATA"] = "api/reducer/SAVE_MY_DATA";
  PersonalDataActions["LOAD_BUSINESS_PARTNER"] = "api/reducer/LOAD_BUSINESS_PARTNER";
  PersonalDataActions["IS_LOADING"] = "api/reducer/IS_PERSONAL_DATA_LOADING";
  PersonalDataActions["RESET_PASSWORD_INITIATE"] = "api/reducer/RESET_PASSWORD_INITIATE";
  PersonalDataActions["RESET_PASSWORD_VALIDATE"] = "api/reducer/RESET_PASSWORD_VALIDATE";
  PersonalDataActions["RESET_PASSWORD_SET"] = "api/reducer/RESET_PASSWORD_SET";
  PersonalDataActions["SET_API_ERROR"] = "api/reducer/SET_API_ERROR";
  PersonalDataActions["CLEAR_API_ERROR"] = "api/reducer/CLEAR_API_ERROR";
  return PersonalDataActions;
}({});
function setLoader(dispatch) {
  var isLoading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  dispatch({
    type: PersonalDataActions.IS_LOADING,
    isLoadingPersonalData: isLoading
  });
}
function setApiError(dispatch) {
  var hasApiError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var error = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    message: ''
  };
  dispatch({
    type: PersonalDataActions.SET_API_ERROR,
    hasApiError: hasApiError,
    apiErrorMessage: error.message
  });
}
function loadCurrentPersonalData(dispatch, contractId) {
  setLoader(dispatch);
  (0, _myDataApi.getPersonalData)(contractId).then(function (response) {
    dispatch({
      type: PersonalDataActions.LOAD_CURRENT_PERSONAL_DATA,
      myData: _objectSpread({}, response.data),
      data: _objectSpread({}, response.data)
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
}
function resetApiError(dispatch) {
  dispatch({
    type: PersonalDataActions.CLEAR_API_ERROR
  });
}
function savePersonalData(dispatch, contractId, myData) {
  setLoader(dispatch);
  return (0, _myDataApi.saveMyData)(contractId, myData).then(function (response) {
    dispatch({
      type: PersonalDataActions.SAVE_MY_DATA,
      myData: response.data,
      data: _objectSpread({}, response.data)
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
}
function loadBusinessPartner(dispatch) {
  setLoader(dispatch);
  (0, _myDataApi.getBusinessPartner)().then(function (response) {
    dispatch({
      type: PersonalDataActions.LOAD_BUSINESS_PARTNER,
      businessPartner: response.data
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
}
function passwordReset(dispatch, emailDataObj) {
  setLoader(dispatch);
  return (0, _accountDataApi.resetPasswordInitiate)(emailDataObj, null).then(function (response) {
    dispatch({
      type: PersonalDataActions.RESET_PASSWORD_INITIATE,
      phoneNumber: response.data.content
    });
  }).catch(function (error) {
    setApiError(dispatch, true, error);
  });
}